export const CASH_FLOW_CREATE = 'cashFlowCreate'
export const CASH_FLOW_EDIT = 'cashFlowEdit'
export const CASH_FLOW_DELETE = 'cashFlowDelete'
export const CASH_FLOW_GET = 'cashFlowGet'
export const CASH_FLOWS_GET = 'cashFlowsGet'
export const CASH_FLOWS_BM_GET = 'cashFlowsBMGet'
export const CASH_FLOWS_SIMPLE_BM_GET = 'cashFlowsSimpleBMGet'
export const CASH_FLOW_SEARCH = 'cashFlowSearch'
export const CASH_FLOW_ACTIVE = 'cashFlowActive'
export const CASH_FLOW_INACTIVE = 'cashFlowInactive'